import React from 'react';
import { FormattedMessage } from "react-intl";
import { inject, observer } from "mobx-react";

import { modelOf } from "../../../../prop-types";
import CheckoutStore from "../../../../store/CheckoutStore";
import PrivacyStatementLink from "../../../legal/PrivacyStatementLink";
import TermsOfDeliveryStatementLink from "../../../legal/TermsOfDeliveryStatementLink";

const CheckoutTerms = ({ checkoutStore }) => {
  const { info_pages } = checkoutStore.order;
  const privacyTerms = (
    <PrivacyStatementLink>
      <FormattedMessage
        id="privacyStatement.subscriberAgreesLink"
        defaultMessage="the Privacy Statement"
      />
    </PrivacyStatementLink>
  );
  const deliveryTerms= <TermsOfDeliveryStatementLink />;

  let message = (
    <FormattedMessage
      id="checkout.termsStatement"
      defaultMessage="By ordering, you accept {privacyStatement} and {deliveryTerms}."
      values={{
        privacyStatement: privacyTerms,
        deliveryTerms: deliveryTerms,
      }}
    />
  );

  let singleTerm = null;

  // We suppose here that either one is valid.
  if (info_pages.DELIVERY_TERMS === null) {
    singleTerm = privacyTerms;
  } else if (info_pages.PRIVACY_TERMS === null) {
    singleTerm = deliveryTerms;
  }

  if (singleTerm) {
    message = (
      <FormattedMessage
        id="checkout.termStatement"
        defaultMessage="By ordering, you accept {term}."
        values={{
          term: singleTerm,
        }}
      />
    );
  }

  return (
    <div className="CheckoutTerms">
      {message}
    </div>
  );
};

CheckoutTerms.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
};

export default inject("checkoutStore")(observer(CheckoutTerms));
